export default __webpack_public_path__ + "static/media/OneDayBefore.bcc23086.png";